export default "__VITE_ASSET__DsgCM94Q__"